/**************************************************
 * Nombre:       Info_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Tab, Tabs, Typography} from "@mui/material";
import {useEffect, useState} from "react";

const Info_Producto = ({item}) => {
    const [escogido, setEscogido] = useState('none');

    const obtenerTexto = (es) =>{

        if (escogido === 'none'){
            return ''
        }

        let index = item.informaciones.findIndex((e) => e.nombre === es);
        return item.informaciones[index].descripcion;

    }

    useEffect(() => {

        if (item && item.informaciones && item.informaciones[0]){
            setEscogido(item.informaciones[0].nombre);
        }

    },[item]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Tabs value={escogido} onChange={(e, v) => setEscogido(v)} variant={'scrollable'}
                      allowScrollButtonsMobile
                >

                    {item.informaciones && item.informaciones.map((e, i) => (
                        <Tab label={e.nombre} value={e.nombre} sx={{textTransform: 'none', fontSize: 18, fontWeight: 600,px: 4}}/>
                    ))}

                </Tabs>

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',mt: 2}}>
                <Typography>
                    {obtenerTexto(escogido)}
                </Typography>
            </Grid>

        </Grid>
    )

}
export default Info_Producto
